import './highcharts';
import 'highcharts/es-modules/masters/modules/treemap.src.js';
import { Chart } from './Chart';
import type { ChartProps } from './Chart';

/**
 * Loads the Highcharts treemap module before rendering the shared Seeq chart
 * wrapper.
 */
export const TreemapChart = ({ onReady, options, ...rest }: ChartProps) => {
  return <Chart {...rest} options={options} onReady={onReady} />;
};
